var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader, Message } from "sb-resp-ui";
// external components
import * as CMP from "./components";
let RacingFutureEvents = class RacingFutureEvents extends React.Component {
    constructor(props) {
        super(props);
        this.dict = this.props.dict;
        this.state = {
            dataProvider: this.props.dataProvider,
        };
    }
    /* istanbul ignore next */
    renderRows(rows) {
        return rows.map(x => {
            return (React.createElement(CMP.Row, { key: x.id },
                React.createElement(CMP.Cta, { url: this.state.dataProvider.getFutureEventUrl(x.urlCode, x.leagueId), handler: this.state.dataProvider.getFutureEventHandler(x) },
                    React.createElement(CMP.League, { date: x.formattedDate, time: x.formattedTime, label: x.eventName }),
                    React.createElement(CMP.Icon, null))));
        });
    }
    /* istanbul ignore next */
    renderLoader() {
        return (React.createElement("div", { className: "rj-racing-future-events__loader" },
            React.createElement(Loader, null)));
    }
    /* istanbul ignore next */
    renderMessage() {
        return React.createElement(Message, { text: "test message" });
    }
    /* istanbul ignore next */
    render() {
        let l = this.state.dataProvider.getAntepostEvents.length;
        return (React.createElement("div", { className: "rj-racing-future-events" },
            !l && this.renderLoader(),
            false && this.renderMessage(),
            (l > 0) && this.renderRows(this.state.dataProvider.getAntepostEvents)));
    }
};
RacingFutureEvents = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RacingFutureEvents);
export { RacingFutureEvents };
//# sourceMappingURL=RacingFutureEvents.js.map